import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { Card, Accordion, Row, Col, Alert } from "react-bootstrap";
import { addContract } from "../../domain/apis/contractService";
import { getCustomers } from "../../domain/apis/customerService";
import { getOrganizations } from "../../domain/apis/organizationService";
import { getVPSs } from "domain/apis/vpsService";
import { getDomains } from "domain/apis/domainService";
import { getPackages } from "domain/apis/packageService";
import _, { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { FormUIItem } from "../commons";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { formatMoney } from "common/Utils";
import { styles } from "./styles";

function ContractModifyComponent({ show, handleClose }) {
  const contractTime = Math.floor(Date.now() / 1000);
  const [formData, setFormData] = useState({ code: `HD${contractTime}` });
  const [error, setError] = useState({});
  const [customerName, setCustomerName] = useState(null);
  const [customers, setCustomers] = useState(null);
  const [masterCustomers, setMasterCustomers] = useState(null);
  const [organizationName, setOrganizationName] = useState(null);
  const [organizations, setOrganizations] = useState(null);
  const [vpsName, setVPSName] = useState(null);
  const [vpsList, setVPSList] = useState(null);
  const [domainName, setDomainName] = useState(null);
  const [domainList, setDomainList] = useState(null);

  const [vpsPackage, setVPSPackage] = useState(null);
  const [domainPackage, setDomainPackage] = useState(null);

  const [vpsPackageList, setVPSPackageList] = useState(null);

  const [domainPackageList, setDomainPackageList] = useState(null);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    getCustomers().subscribe({
      next({ data }) {
        const { value } = data;
        setMasterCustomers(value);
      },
    });

    getOrganizations().subscribe({
      next({ data }) {
        const { value } = data;
        setOrganizations(value.map((obj) => `${obj.name} -- ${obj.id}`));
      },
    });

    getVPSs().subscribe({
      next({ data }) {
        const { value } = data;
        setVPSList(value.map((obj) => `${obj.name} -- ${obj.id}`));
      },
    });

    getDomains().subscribe({
      next({ data }) {
        const { value } = data;
        setDomainList(value.map((obj) => `${obj.name} -- ${obj.id}`));
      },
    });

    getPackages().subscribe({
      next({ data }) {
        const { value } = data;
        setDomainPackageList(
          value
            .filter((obj) => obj.type === "domain")
            .map(
              (obj) =>
                `${obj.name} -- ${formatMoney(obj.price ?? "0")} VND -- ${
                  obj.id
                }`
            )
        );
        setVPSPackageList(
          value
            .filter((obj) => obj.type === "vps")
            .map(
              (obj) =>
                `${obj.name} -- ${formatMoney(obj.price ?? "0")} VND -- ${
                  obj.id
                }`
            )
        );
      },
    });
  }, []);

  useEffect(() => {
    setFormData({
      code: `HD${contractTime}`,
      services: [],
    });
    setCustomerName(null);
  }, []);

  useEffect(() => {
    let arr = organizationName?.split("--") ?? [];
    if (!isEmpty(arr)) {
      let id = arr[arr.length - 1].trim();
      setCustomers(
        masterCustomers
          .filter((o) => o.organizationID === id)
          .map(
            (customer) =>
              `${customer.fullName} -- ${customer.email} -- ${customer.id}`
          )
      );
    } else {
      setCustomers([]);
    }
  }, [organizationName]);

  const handleUpdateForm = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const validateForm = () => {
    var result = true;
    var errorState = {};

    if (isEmpty(formData["name"])) {
      result = false;
      errorState.name = true;
    }

    if (isEmpty(formData["code"])) {
      result = false;
      errorState.code = true;
    }

    if (isEmpty(formData["organizationID"])) {
      result = false;
      errorState.organizationID = true;
    }

    if (isEmpty(formData["services"])) {
      result = false;
      errorState.services = true;
    }

    setError(errorState);
    return result;
  };

  const onModify = () => {
    if (!validateForm()) {
      return;
    }
    addContract(formData).subscribe({
      next: ({ data }) => {
        handleClose({ isReload: true });
      },
    });
  };

  useEffect(() => {
    var invoiceRet = [];
    var services = [];
    if (!isEmpty(vpsName) && !isEmpty(vpsPackage)) {
      let entityArr = vpsName?.split("--") ?? [];
      let packageArr = vpsPackage?.split("--") ?? [];

      if (!isEmpty(entityArr) && !isEmpty(packageArr)) {
        services.push({
          name: entityArr[0],
          entityID: entityArr[entityArr.length - 1].trim(),
          packageID: packageArr[packageArr.length - 1].trim(),
        });
      }

      invoiceRet.push({
        serviceType: "VPS Hosting",
        total: Number(
          vpsPackage
            .split("--")[1]
            .replaceAll("VND", "")
            .replaceAll(",", "")
            .trim()
        ),
      });
    }

    if (!isEmpty(domainName) && !isEmpty(domainPackage)) {
      let entityArr = domainName?.split("--") ?? [];
      let packageArr = domainPackage?.split("--") ?? [];

      if (!isEmpty(entityArr) && !isEmpty(packageArr)) {
        services.push({
          name: entityArr[0],
          entityID: entityArr[entityArr.length - 1].trim(),
          packageID: packageArr[packageArr.length - 1].trim(),
        });
      }

      invoiceRet.push({
        serviceType: "Domain",
        total: Number(
          domainPackage
            .split("--")[1]
            .replaceAll("VND", "")
            .replaceAll(",", "")
            .trim()
        ),
      });
    }

    handleUpdateForm("services", services);
    setInvoices(invoiceRet);
  }, [vpsName, domainName, vpsPackage, domainPackage]);

  useEffect(() => {
    let arr = customerName?.split("--") ?? [];
    if (!isEmpty(arr)) {
      handleUpdateForm("customerID", arr[arr.length - 1].trim());
    }
  }, [customerName]);

  useEffect(() => {
    let arr = organizationName?.split("--") ?? [];
    if (!isEmpty(arr)) {
      handleUpdateForm("organizationID", arr[arr.length - 1].trim());
    }
  }, [organizationName]);

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <Modal.Title>{"HỢP ĐỒNG - DỊCH VỤ"}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="container py-4">
          {/* Thông tin hợp đồng */}
          <Card className="mb-4 p-3">
            <h5 className="mb-3">Thông tin</h5>

            <Form>
              <Row className="mb-3">
                <Col md={6}>
                  <FormUIItem
                    label={"Tên"}
                    code={"name"}
                    error={_.get(error, "name")}
                    errorMessage={"Vui lòng nhập nội dung!"}
                    required
                    placeholder="Nhập tên hợp đồng"
                    handleUpdate={handleUpdateForm}
                  />
                </Col>
                <Col md={6}>
                  <FormUIItem
                    label={"Mã Hợp Đồng"}
                    code={"code"}
                    required
                    disabled
                    error={_.get(error, "code")}
                    errorMessage={"Vui lòng nhập nội dung!"}
                    value={formData.code}
                    placeholder="Nhập mã hợp đồng"
                    // handleUpdate={handleUpdateForm}
                  />
                </Col>
              </Row>

              <Autocomplete
                options={organizations}
                value={organizationName}
                style={{
                  paddingLeft: "0px",
                  width: "100%",
                }}
                onChange={(event, newValue) => {
                  setOrganizationName(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Giáo Phận *"
                    placeholder="Nhập để tìm kiếm..."
                  />
                )}
                sx={{ width: 300 }}
                autoSelect
              />
              <div style={{ height: 16 }} />
              <Autocomplete
                options={customers}
                value={customerName}
                style={{
                  paddingLeft: "0px",
                  width: "100%",
                }}
                onChange={(event, newValue) => {
                  setCustomerName(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Đại diện"
                    placeholder="Nhập để tìm kiếm..."
                  />
                )}
                sx={{ width: 300 }}
                autoSelect
              />

              <FormUIItem
                label={"Mô tả"}
                code={"description"}
                handleUpdate={handleUpdateForm}
              />
            </Form>
          </Card>

          {/* Dịch vụ đi kèm */}
          <Card className="mb-4 p-3">
            <h5 className="mb-3">Dịch vụ</h5>
            <Form>
              <Row className="mb-3">
                <Col md={6}>
                  <Autocomplete
                    options={vpsList}
                    value={vpsName}
                    style={{
                      paddingLeft: "0px",
                      width: "100%",
                    }}
                    onChange={(event, newValue) => {
                      setVPSName(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="VPS - HOSTING"
                        placeholder="Nhập để tìm kiếm..."
                      />
                    )}
                    autoSelect
                  />
                </Col>
                <Col md={6}>
                  <Autocomplete
                    options={vpsPackageList}
                    value={vpsPackage}
                    style={{
                      paddingLeft: "0px",
                      width: "100%",
                    }}
                    onChange={(event, newValue) => {
                      setVPSPackage(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Gói hosting vps"
                        placeholder="Nhập để tìm kiếm..."
                      />
                    )}
                    autoSelect
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Autocomplete
                    options={domainList}
                    value={domainName}
                    style={{
                      paddingLeft: "0px",
                      width: "100%",
                    }}
                    onChange={(event, newValue) => {
                      setDomainName(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tên miền"
                        placeholder="Nhập để tìm kiếm..."
                      />
                    )}
                    autoSelect
                  />
                </Col>
                <Col md={6}>
                  <Autocomplete
                    options={domainPackageList}
                    value={domainPackage}
                    style={{
                      paddingLeft: "0px",
                      width: "100%",
                    }}
                    onChange={(event, newValue) => {
                      setDomainPackage(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Gói tên miền"
                        placeholder="Nhập để tìm kiếm..."
                      />
                    )}
                    autoSelect
                  />
                </Col>
              </Row>
            </Form>
          </Card>

          {/* Hóa đơn liên quan */}
          <Card className="mb-4 p-3">
            <h5 className="mb-3">Hóa đơn</h5>
            <Accordion>
              {invoices.map((invoice, idx) => (
                <Accordion.Item eventKey={String(idx)} key={invoice.id}>
                  <Accordion.Header>{invoice.serviceType}</Accordion.Header>
                  <Accordion.Body>
                    <p style={styles.textNormal}>
                      Đơn giá: {formatMoney(invoice.total)} VND
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
            <div style={{ display: "inline-block", marginTop: 16 }}>
              <h5>
                <b>Thành tiền: </b>
                {formatMoney(
                  invoices
                    .map((o) => o.total)
                    .reduce((prv, current) => prv + current, 0)
                )}{" "}
                VND
              </h5>
            </div>
          </Card>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleClose()}>
          Hủy
        </Button>
        <Button variant="primary" onClick={() => onModify()}>
          Lưu
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ContractModifyComponent;
